import React, { CSSProperties, SyntheticEvent, useEffect, useMemo, useState } from "react";
import {
  List,
} from "semantic-ui-react";
import { BranchType } from "./segmentTreeType";
import SegmentTargetTreeChild, { SegmentTargetTreeType } from "./SegmentTargetTreeChild";


const SegmentTargetTree = (props: SegmentTargetTreeType) => {
  console.log('CardSegmSegmentTargetTreeentTargetTree props: ', props);
  // <id, true/false>  สำหรับ control expand/collapse
  const [hideMap, setHideMap] = useState<{ [key: string]: boolean }>({});

  const handleToggle = (id: string) => {
    setHideMap((prev) => ({
      ...prev,
      [id]: !prev?.[id],
    }));
  };

  console.log("CardSegementTargetTree expandedMap: ", hideMap);
  console.log("CardSegementTargetTree props:", props);
  return (
    <div>
      {(props.listTrees || [])
      .map((item: BranchType, index: number) => (
        <List key={item.id}>
          <SegmentTargetTreeChild
            key={item.id}
            node={item}
            onSelectedSegmentId={props.onSelectedSegmentId}
            SegmentTargetSequence={props.SegmentTargetSequence}
            onAddNode={props.onAddNode}
            onRemove={props.onRemove}
            isLast={index === (props.listTrees || []).length - 1}
            isFirst={true}
            hideMap={hideMap}
            onToggle={handleToggle}
            onEditTress={props.onEditTress}
          />
        </List>
      ))}
    </div>
  );
};

SegmentTargetTree.displayName = "SegmentTargetTree";

export default React.memo(SegmentTargetTree);
